import React from 'react'
import { FormControl } from 'react-bootstrap'
import '../../../index.css'


let sizeValues = []

/**
 * Handles the size values and the input forms for setting transaction amounts
 * @param {object[]} showSizes sizes to be shown for a specific articleType
 */
const SizesControl = ({ showSizes }) => {
    sizeValues = []
    /**
     * Sets default values for each size visible
    */
    function setSizeDefaults() {
        showSizes.map(size => sizeValues.push({ size: size, amount: 0 }))
    }
    
    if (showSizes[0] != null) {
        setSizeDefaults()

        return (
            showSizes.map(entry =>
                <div className="form-inline order-input-form">
                    <div className="controlTitle" className="number-input-title">{entry.SizeValue}:</div>
                    <div className="number-input-title">({entry.AmountInStorage})</div>
                    <FormControl className="form number-input" min="0" defaultValue="" id={entry.SizeValue} type="number"
                            onChange={handleChange} size="sm" />
                </div>
            )
        )
    } else {
        return (null)
    }
}

/**
 * On change handler for input fields, manages the specific amount set by user
 * @param {string} value
 */
const handleChange = value => {
    let entry = sizeValues.findIndex(x => x.size.SizeValue == value.target.id)
    sizeValues[entry].amount = value.target.value
}
export {sizeValues}

export { SizesControl }

